import React from 'react';
import useReveal from '../hooks/useReveal';
import './Location.css';

export default function Location() {
  const mapSrc = `https://maps.google.com/maps?q=Dundigal+Hyderabad+Telangana+500043&z=15&output=embed`;
  const ref = useReveal();

  return (
    <section className="location-section" id="location" ref={ref}>
      {/* decorative blobs */}
      <div className="loc-blob loc-blob-1" />
      <div className="loc-blob loc-blob-2" />

      <div className="section-header reveal">
        <h2>Location</h2>
        <p>Visit our farm or reach out — we're always happy to welcome you.</p>
      </div>

      <div className="location-content">
        {/* Map */}
        <div className="map-wrap reveal-left">
          <div className="map-frame">
            <iframe
              title="Adiyogi Natural Farms Location"
              src={mapSrc}
              width="100%"
              height="100%"
              style={{ border: 0, display: 'block' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="map-overlay">
              <a
                href="https://maps.app.goo.gl/i8PrWvpPnYaaqW8i6"
                target="_blank"
                rel="noopener noreferrer"
                className="map-directions-btn"
              >
                <span>🗺</span> Get Directions
              </a>
            </div>
          </div>
        </div>

        {/* Address card */}
        <div className="address-card reveal-right">
          <div className="address-card-top">
            <div className="pin-circle">
              <span>📍</span>
            </div>
            <div>
              <h3>Adiyogi Natural Farms</h3>
              <span className="address-tag">Organic Farm</span>
            </div>
          </div>

          <div className="address-body">
            <div className="address-row">
              <span className="addr-icon">🕐</span>
              <div>
                <p className="addr-label">Working Hours</p>
                <p className="addr-value">Monday - Sunday &nbsp; 8AM – 6PM</p>
              </div>
            </div>
            <div className="address-row">
              <span className="addr-icon">📞</span>
              <div>
                <p className="addr-label">Phone</p>
                <a href="tel:+916305214522" className="addr-value addr-link">+91 63052 14522 </a>
              </div>
            </div>
            <div className="address-row">
              <span className="addr-icon">✉</span>
              <div>
                <p className="addr-label">Email</p>
                <a href="mailto:support@adiyoginaturalfarms.com" className="addr-value addr-link">support@adiyoginaturalfarms.com
                </a>
              </div>
            </div>
            <div className="address-row">
              <span className="addr-icon">🏘</span>
              <div>
                <p className="addr-label">Address</p>
                <p className="addr-value">Near ORR Exit 5 <br /> Dundigal, Hyderabad <br />Telangana — <strong>500043</strong></p>
              </div>
            </div>
          </div>

          <a
            href="https://maps.app.goo.gl/i8PrWvpPnYaaqW8i6"
            target="_blank"
            rel="noopener noreferrer"
            className="visit-btn"
          >
            <span>📍</span> Open in Google Maps
          </a>
        </div>
      </div>
    </section>
  );
}
